import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { TierProvider } from '@/v2/motion/tiers'
import { surfaceRoutes } from '@/v2/routes'
import { AppShellV2 } from '@/v2/shell/AppShellV2'
import { ErrorBoundaryV2 } from '@/v2/shell/ErrorBoundaryV2'

const CallGuest = lazy(() => import('@/routes/CallGuest'))
const OfficeGuest = lazy(() => import('@/routes/OfficeGuest'))

/**
 * office.tovie.it.com serves the office surface DIRECTLY to walk-in customers
 * (public guest mode) — no hub, no operator shell. We branch on the host the
 * same way `calls.tovie.it.com` serves the guest call page from the shared dist.
 */
const IS_OFFICE_HOST =
  typeof window !== 'undefined' && window.location.hostname === 'office.tovie.it.com'

/**
 * Hub V2 (mission control). The route table lives in src/v2/routes.tsx
 * and is shared between the floor (here, under the shell layout route)
 * and workspace windows (each under its own memory router).
 */
export default function App() {
  return (
    <TierProvider>
      <ErrorBoundaryV2 scope="shell">
        {IS_OFFICE_HOST ? (
          // Public office host — every path lands in reception as a guest, so a
          // deep link or refresh never escapes into the operator app.
          <Suspense fallback={null}>
            <Routes>
              <Route path="*" element={<OfficeGuest />} />
            </Routes>
          </Suspense>
        ) : (
          <Routes>
            {/* Public client-facing guest call — OUTSIDE the operator shell. */}
            <Route path="call/g/:token" element={<CallGuest />} />
            <Route element={<AppShellV2 />}>{surfaceRoutes()}</Route>
          </Routes>
        )}
      </ErrorBoundaryV2>
    </TierProvider>
  )
}
